import { connect } from 'react-redux'
import './FileUpload.scss'
import { useRef, useState } from 'react'
import { LuxButton, LuxIcon, Color, LuxPhotoFullScreen } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { usePhotoFullScreen } from '@/app/hooks/usePhotoFullScreen'
import { isMobile } from 'react-device-detect'

const FileUpload = (props) => {
    const componentClass = 'smart-modals-file-upload'
    const { form, onSave, disabled } = props
    const intl = useIntl()
    const inputRef = useRef(null)
    const inputCaptureRef = useRef(null)
    // const isMobile = useWindowResize()

    const [dragActive, setDragActive] = useState(false)

    const {
        // imageList,
        // uploadedImageList,
        selectedImage,
        setSelectedImage,
        selectedImageInfo,
        enabledEdit,
        onRemoveTag,
        onNewTagPosition,
        onCloseFullScreen,
        previousImage,
        nextImage,
        editLoading,
        setEditLoading,
        onEdit,
    } = usePhotoFullScreen({})

    const onEditDone = (blob: Blob) => {
        let file = new File([blob], form.cover.value.file?.name || form.title.value + ' cover')
        const reader: any = new FileReader()

        reader.onloadend = async () => {
            setSelectedImage(reader.result.toString())
        }

        onSave({
            ...form,
            cover: {
                ...form.cover,
                value: { file: file, src: URL.createObjectURL(file) },
            },
        })

        onCloseFullScreen()
    }

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            if (!disabled) setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }
    const handleDrop = function (e) {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (
            !!props.inputProps?.accept &&
            props.inputProps?.accept.indexOf(e.dataTransfer.files[0].name.split('.').pop()) === -1
        ) {
            props.onFormatError()
            return
        }
        if (e.dataTransfer.files[0].size > 20971520) {
            props.onSizeError()
        }
        if (
            e.dataTransfer.files &&
            e.dataTransfer.files[0] &&
            e.dataTransfer.files[0].size <= 20971520 &&
            (!props.inputProps?.accept ||
                props.inputProps?.accept.indexOf(e.dataTransfer.files[0].name.split('.').pop()) >
                    -1)
        ) {
            if (!disabled)
                onSave({
                    ...form,
                    cover: {
                        ...form.cover,
                        value: {
                            file: e.dataTransfer.files[0],
                            src: URL.createObjectURL(e.dataTransfer.files[0]),
                        },
                    },
                })
            // at least one file has been dropped so do something
            // handleFiles(e.dataTransfer.files);
        }
    }
    const handleChange = function (e) {
        e.preventDefault()
        if (
            !!props.inputProps?.accept &&
            props.inputProps?.accept.indexOf(e.target.files[0].name.split('.').pop()) === -1
        ) {
            props.onFormatError()
            return
        }
        if (e.target.files[0].size > 20971520) {
            props.onSizeError()
        }
        if (
            e.target.files &&
            e.target.files[0] &&
            e.target.files[0].size <= 20971520 &&
            (!props.inputProps?.accept ||
                props.inputProps?.accept.indexOf(e.target.files[0].name.split('.').pop()) > -1)
        ) {
            onSave({
                ...form,
                cover: {
                    ...form.cover,
                    value: { file: e.target.files[0], src: URL.createObjectURL(e.target.files[0]) },
                },
            })
            // at least one file has been selected so do something
            // handleFiles(e.target.files);
        }
    }
    const onSelect = () => {
        inputRef.current.click()
    }

    const onCaptureSelect = () => {
        inputCaptureRef.current.click()
    }

    return (
        <div className={componentClass}>
            {form.cover.value.src && (
                <div
                    className={`${componentClass}__button-container`}
                    style={{ justifyContent: 'flex-end' }}>
                    <div className={`${componentClass}__image-cta`}>
                        <LuxIcon
                            icon="pencil"
                            onClick={onEdit.bind(null, {
                                url: form.cover.value.src,
                                name: form.cover.value.file?.name || form.title.value + ' cover',
                                position: 1,
                            })}
                        />
                    </div>
                </div>
            )}
            <form
                id="form-file-upload"
                onDragEnter={handleDrag}
                onSubmit={(e) => e.preventDefault()}>
                <input
                    ref={inputRef}
                    type="file"
                    id="input-file-upload"
                    multiple={true}
                    onChange={handleChange}
                    capture={isMobile}
                    disabled={disabled}
                    {...props.inputProps}
                />
                <label
                    id="label-file-upload"
                    htmlFor="input-file-upload"
                    className={dragActive ? 'drag-active' : ''}>
                    <div>
                        {!form.cover.value.src && (
                            <div className={`${componentClass}__button-container`}>
                                <LuxButton
                                    onClick={onSelect}
                                    text={intl.formatMessage({
                                        id: 'modals.file.upload.load',
                                        defaultMessage: 'Upload image',
                                    })}
                                    color={Color.BG_GREY}
                                    iconLeft={'plus'}
                                />
                                {isMobile && (
                                    <LuxButton
                                        onClick={onCaptureSelect}
                                        text={intl.formatMessage({
                                            id: 'modals.file.upload.take',
                                            defaultMessage: 'Take photo',
                                        })}
                                        color={Color.BG_GREY}
                                        iconLeft={'camera'}
                                    />
                                )}
                            </div>
                        )}
                        {form.cover.value.src && (
                            <div className={`${componentClass}__image`}>
                                <img src={form.cover.value.src} />
                                <div className={`${componentClass}__image-cta-container`}>
                                    <div className={`${componentClass}__image-cta`}>
                                        <LuxIcon
                                            icon="upload"
                                            onClick={(e) => {
                                                e.stopEventPropagation()
                                                onSelect
                                            }}
                                        />
                                    </div>
                                    <div className={`${componentClass}__image-cta`}>
                                        <LuxIcon
                                            icon="expand"
                                            onClick={() =>
                                                window.open(form.cover.value.src, '_blank')
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </label>
                {selectedImage && (
                    <LuxPhotoFullScreen
                        selectedImage={selectedImage}
                        imageInfo={selectedImageInfo}
                        enabledEdit={enabledEdit}
                        disableTag={true}
                        disableInfo={true}
                        totalImage={1}
                        editLoading={editLoading}
                        setEditLoading={setEditLoading}
                        onNewTagPosition={onNewTagPosition}
                        onClose={onCloseFullScreen}
                        onRemoveTag={onRemoveTag}
                        onEditDone={onEditDone}
                        previousImage={previousImage}
                        nextImage={nextImage}
                        intl={intl}
                        onEnableRotate={() => {
                            document.getElementsByClassName(
                                'full-screen-container-overlay'
                            )[0].className =
                                document.getElementsByClassName('full-screen-container-overlay')[0]
                                    .className + ' enable-rotate'
                        }}
                        onEnableCrop={() => {
                            document.getElementsByClassName(
                                'full-screen-container-overlay'
                            )[0].className =
                                document.getElementsByClassName('full-screen-container-overlay')[0]
                                    .className + ' enable-crop'
                        }}
                    />
                )}
                {dragActive && (
                    <div
                        id="drag-file-element"
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}></div>
                )}
            </form>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload)
